import dayjs, { Dayjs } from 'dayjs';

export type BookingCutoffSettings = {
  booking_cutoff_enabled?: boolean;
  booking_cutoff_time?: string | null;
};

const CUTOFF_TIME_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/;

export function isCutoffFeatureActive(settings?: BookingCutoffSettings | null): boolean {
  if (!settings?.booking_cutoff_enabled) return false;
  const time = settings.booking_cutoff_time;
  return !!time && CUTOFF_TIME_PATTERN.test(time);
}

export function isPastCutoff(settings?: BookingCutoffSettings | null, now: Dayjs = dayjs()): boolean {
  if (!isCutoffFeatureActive(settings)) return false;
  const [hour, minute] = settings!.booking_cutoff_time!.split(':').map(Number);
  const cutoffMoment = now.startOf('day').hour(hour).minute(minute).second(0).millisecond(0);
  return !now.isBefore(cutoffMoment);
}

// Shared by disabledDate and default-date logic
export function getEffectiveMinSelectableDate(settings?: BookingCutoffSettings | null, now: Dayjs = dayjs()): Dayjs {
  return isPastCutoff(settings, now) ? now.add(1, 'day').startOf('day') : now.startOf('day');
}

export function isCheckInDateBlocked(
  checkIn: Dayjs | null | undefined,
  settings?: BookingCutoffSettings | null,
  now: Dayjs = dayjs(),
): boolean {
  if (!checkIn) return false;
  if (!isPastCutoff(settings, now)) return false;
  return checkIn.isSame(now, 'day');
}
